module.exports = __webpack_public_path__ + "img/nt54-05-80-1.prt.6ee3cdad.jpg";